module.exports = ".margin9{\n    margin-right: 9%;\n}\n.textCle{\n    width: 40%;\n}\n.margin9Left{\n    margin-left: 6%;\n}\n.margin20Top{\n    margin-top: 20px;\n    margin-bottom: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.css
// module id = ./src/app/register/register.component.css
// module chunks = main